import React from 'react';
import './PetAnimations.css';

export default function StriderSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#8B2252';
  const lightColor = color ? lighten(color) : '#A83868';
  const darkColor = color ? darken(color) : '#5C1638';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Long legs */}
      <line x1="45" y1="62" x2="35" y2="105" stroke={darkColor} strokeWidth="4" strokeLinecap="round" />
      <line x1="55" y1="65" x2="48" y2="105" stroke={darkColor} strokeWidth="4" strokeLinecap="round" />
      <line x1="65" y1="65" x2="72" y2="105" stroke={darkColor} strokeWidth="4" strokeLinecap="round" />
      <line x1="75" y1="62" x2="85" y2="105" stroke={darkColor} strokeWidth="4" strokeLinecap="round" />
      {/* Feet */}
      <ellipse cx="35" cy="107" rx="4" ry="2" fill={darkColor} />
      <ellipse cx="48" cy="107" rx="4" ry="2" fill={darkColor} />
      <ellipse cx="72" cy="107" rx="4" ry="2" fill={darkColor} />
      <ellipse cx="85" cy="107" rx="4" ry="2" fill={darkColor} />
      {/* Dripping texture from body */}
      <path d="M42 62C42 66 40 72 41 75" stroke={lightColor} strokeWidth="2" strokeLinecap="round" />
      <path d="M55 68C55 72 54 77 55 80" stroke={lightColor} strokeWidth="2" strokeLinecap="round" />
      <path d="M72 66C72 70 73 76 72 79" stroke={lightColor} strokeWidth="2" strokeLinecap="round" />
      <path d="M80 60C80 64 81 69 80 72" stroke={lightColor} strokeWidth="2" strokeLinecap="round" />
      {/* Body */}
      <ellipse cx="60" cy="50" rx="24" ry="18" fill={bodyColor} />
      {/* Body texture / warty bumps */}
      <circle cx="48" cy="45" r="3" fill={lightColor} opacity="0.5" />
      <circle cx="68" cy="42" r="2.5" fill={lightColor} opacity="0.5" />
      <circle cx="58" cy="55" r="2" fill={lightColor} opacity="0.5" />
      {/* Head */}
      <ellipse cx="60" cy="35" rx="18" ry="14" fill={bodyColor} />
      {/* Hair / top bristles */}
      <path d="M48 24C46 18 50 16 52 22" stroke={darkColor} strokeWidth="2" strokeLinecap="round" />
      <path d="M56 22C55 15 59 13 60 20" stroke={darkColor} strokeWidth="2" strokeLinecap="round" />
      <path d="M64 22C63 15 67 14 68 21" stroke={darkColor} strokeWidth="2" strokeLinecap="round" />
      <path d="M72 24C74 18 70 16 68 22" stroke={darkColor} strokeWidth="2" strokeLinecap="round" />
      {/* Eyes - sad/droopy */}
      <ellipse cx="52" cy="34" rx="4" ry="3.5" fill="white" />
      <ellipse cx="68" cy="34" rx="4" ry="3.5" fill="white" />
      <ellipse cx="53" cy="35" rx="2.5" ry="2.5" fill="#2C2419" />
      <ellipse cx="69" cy="35" rx="2.5" ry="2.5" fill="#2C2419" />
      <circle cx="54" cy="33.5" r="1" fill="white" />
      <circle cx="70" cy="33.5" r="1" fill="white" />
      {/* Sad eyebrow lines */}
      <path d="M48 30C50 28 54 29 56 30" stroke={darkColor} strokeWidth="1.2" strokeLinecap="round" fill="none" />
      <path d="M64 30C66 29 70 28 72 30" stroke={darkColor} strokeWidth="1.2" strokeLinecap="round" fill="none" />
      {/* Nose */}
      <ellipse cx="60" cy="39" rx="2" ry="1.2" fill={darkColor} />
      {/* Mouth - slight frown */}
      <path d="M55 42C57 44 63 44 65 42" stroke={darkColor} strokeWidth="1" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
